import Btn from "@components/Btn";
import { useEffect } from "react";
import { HOME_BUTTON_SEPARATOR, HP_ANIMATIONS, HP_ANIMATION_TYPE } from "@lib/constants";
import { useSelector } from "react-redux";
import EverythingButton from "../Buttons/everythingButton";
import OverviewButton from "../Buttons/overviewButton";
import PersonaliseButton from "../Buttons/personaliseButton";
import ProspectusButton from "../Buttons/prospectusButton";

import { staggerAnimations } from '@lib/helpers';
import { initTriggeredAnimations } from '@lib/helpers/blockAnimations';

export default function ProspectusButtons() {
	const { prospectusId, authenticated, authStatus } = useSelector((state) => state.user);

	const animationClass = HP_ANIMATIONS && HP_ANIMATION_TYPE
	? `animate ${HP_ANIMATION_TYPE} hp-has-triggered-animation`
	: '';

	const animationData =
	HP_ANIMATIONS && HP_ANIMATION_TYPE
		? {
				'data-hp-trigger-selector': '',
				'data-hp-triggered-animation':
					HP_ANIMATION_TYPE,
				'data-hp-trigger-event':
					'viewport',
				'data-hp-triggered-played' : '0',
			}
		: {};

	useEffect(() => {
		staggerAnimations();
		initTriggeredAnimations();
	}, []);

	if ('finished' === authStatus) {
		return (
			<>
				<PersonaliseButton />
				{HOME_BUTTON_SEPARATOR && (
					<span className={`homeLabelSeparator  ${style.labelSeparator}`}>{HOME_BUTTON_SEPARATOR}</span>
				)}
				<EverythingButton />
				{authenticated && prospectusId ? (
					<ProspectusButton classes={['outline', 'mb-2', 'outline--home']} />
				) : (
					<OverviewButton />
				)}
			</>
		);
	}

	return (
		<>
			<Btn
				customClass={['primary', 'mb-2', 'primary--home', 'BtnPrimary_Home', 'skeleton', `${animationClass}`]}
				{...animationData}
			></Btn>
			<Btn
				customClass={['primary', 'mb-2', 'primary--home', 'BtnPrimary_Home', 'skeleton', `${animationClass}`]}
				{...animationData}
			></Btn>
		</>
	);
}
